import { useContext } from "react";
import { Box, Button, Grid, MenuItem, TextField } from "@mui/material";
import { absencesContext } from '../AbsencesContext';
import { MdSearch as SearchIcon } from 'react-icons/md';
import { applicationContext } from "helpers/services";
import { FilterContainer } from "components";
import { DateRangePicker, DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import moment from 'moment';


let Filter = () => {
    let service = useContext(absencesContext);
    let appService = useContext(applicationContext);


    return (
        <FilterContainer onSubmit={() => service.doSearch(service.search)}>
            <Grid item xs md lg={2}>
                <TextField
                    select
                    label="Utente"
                    size="small"
                    variant="standard"
                    value={service.search.userName}
                    onChange={(e: any) => service.handleChange({ ...service.search, userName: e.target.value })}
                >
                    <MenuItem value={''}>--</MenuItem>
                    {appService.simecUsers
                        .filter(x => x.isDisabled === false)
                        .filter(x => x.simecClaims.canGoToCustomer === true)
                        .map(u => <MenuItem key={u.email} value={u.email}>{u.firstName} {u.lastName}</MenuItem>)}
                </TextField>
            </Grid>
            <Grid item xs md lg={2}>
                <DateRangePicker
                    startText="Da data"
                    endText="A data"
                    value={[service.search.dateFrom, service.search.dateTo]}
                    onChange={(newValue: DateRange<Date>) =>
                        service.handleChange({
                            ...service.search,
                            dateFrom: newValue && moment(newValue[0]).utc(true),
                            dateTo: newValue && moment(newValue[1]).utc(true)
                        })
                    }
                    renderInput={(startProps, endProps) => (
                        <>
                            <TextField {...startProps} variant="standard"
                                onChange={(e) => {
                                    if (!e.target.value)
                                        service.handleChange({
                                            ...service.search,
                                            dateTo: e.target.value
                                        })
                                }}
                            />
                            <Box sx={{ ml: 1.5 }} />
                            <TextField {...endProps} variant="standard" />
                        </>
                    )}
                />
            </Grid>
            <Grid item xs md lg={2}>
                <Button
                    color="secondary"
                    variant="outlined"
                    aria-label="cerca"
                    onClick={() => service.searchAbsences(service.search)}
                >
                    <SearchIcon />
                </Button>
            </Grid>
        </FilterContainer>
    );
}

export default Filter;